import { ethers } from 'ethers';

export const ZERO = ethers.constants.Zero;
export const ONE = ethers.constants.One;
export const ADDRESS_ZERO = ethers.constants.AddressZero;
export const MAX_UINT = ethers.constants.MaxUint256;

export const toEther = (bignum) => +ethers.utils.formatEther(bignum);

export const parseEther = (str) => ethers.utils.parseEther(str);

export const formatEther = (bignum, maximumFractionDigits = 2) =>
  toEther(bignum).toLocaleString('en-US', { maximumFractionDigits });

export const range = (start, stop, step = 1) =>
  Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);

export const estimateGasLimit = (contract, method, ...args) =>
  contract.estimateGas[method](...args).then((gasLimit) =>
    gasLimit.mul(125).div(100)
  );
